module.exports = __webpack_public_path__ + "img/menu_DATAROOM.dcacb094.svg";